import Theme from 'LegacyWeployDesignLanguage/Theme';
import { css } from 'styled-components';

const styles = () => ({
  icon: {
    color: Theme.colors.iconColor,
    fontSize: '28px',
    verticalAlign: 'middle',
  },
});

export const commonIconStyles = css`
  color: ${props => props.theme.colors.iconColor};

  ${props => props.color && css`
    color: ${props.color};
  `};

  font-size: ${props => props.theme.icons.default};
  vertical-align: middle;
`;

export default styles;
